<template>
    <div id="legal-mention-view" class="bg-white ms-2 me-2 mt-4 mb-4 p-4 text-medium">
      <div class="w-75 m-auto mt-4 pt-4">
        <p class="mb-0">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_OPENING_1) }}</p>
        <p>{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_OPENING_2) }}</p>
        <p class="mt-4 mb-4 fw-normal">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_RESPONSIBILITY_LIMITATION_TITLE) }}</p>
        <p>{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_RESPONSIBILITY_LIMITATION_TEXT_1) }}</p>
        <p class="mb-1 text-decoration-underline">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_RESPONSIBILITY_LIMITATION_INTELECTUAL_PROPERTTY_SUBTITLE) }}</p>
        <p class="mb-1">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_RESPONSIBILITY_LIMITATION_INTELECTUAL_PROPERTTY_TEXT_1) }}</p>
        <p>{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_RESPONSIBILITY_LIMITATION_INTELECTUAL_PROPERTTY_TEXT_2) }}</p>

        <p class="mt-4 mb-4 fw-normal">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_PERSONAL_DATA_TITLE) }}</p>
        <p class="mb-1">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_PERSONAL_DATA_TEXT_1) }}</p>
        <p class="mb-1">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_PERSONAL_DATA_TEXT_2) }}</p>
        <p class="mb-1">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_PERSONAL_DATA_TEXT_3) }}</p>
        <p class="mb-1">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_PERSONAL_DATA_TEXT_4) }}</p>
        <p class="mb-1">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_PERSONAL_DATA_TEXT_5) }}</p>
        <p class="mb-1">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_PERSONAL_DATA_TEXT_6) }}</p>
        <p class="mb-1">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_PERSONAL_DATA_TEXT_7) }}</p>
        <p class="mb-1">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_PERSONAL_DATA_TEXT_8) }}</p>

        <p class="mt-4 mb-4 fw-normal">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_GENERAL_DISPOSITION_TITLE) }}</p>
        <p class="mb-1">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_GENERAL_DISPOSITION_TEXT) }}</p>

        <p class="mt-4 mb-4 fw-normal">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_CHALLENGE_TITLE) }}</p>
        <p class="mb-1">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_CHALLENGE_TEXT_1) }}</p>
        <p class="mb-1">{{ languageStore.text(TEXT_KEYS.LEGAL_MENTION_CHALLENGE_TEXT_2) }}</p>
      </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import { useLanguageStore } from "@/stores/language";

import { TEXT_KEYS } from "@/constants";

@Options({
  components: {
  }
})
export default class Legal extends Vue {
  languageStore = useLanguageStore()

  TEXT_KEYS = TEXT_KEYS
}
</script>

<style lang="stylus">
</style>